/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import {
  Add91Note, ShowError, OperationModal, FormCard,
} from './common';
import './BlockSender.css';
import {

  sess_delete,
  sess_get,
  sess_post,

} from '../../utils/HttpRequests';

const URL_DELETE_SENDER_ID = 'admin/console/delete-sender-from-block-list';
const URL_GET_ALL_SPAM_SENDERS = 'admin/console/spam-senders';

function BlockSender() {
  const [blockedSenders, setBlockedSenderIds] = useState([]);
  const [spamSenders, setSpamSenderIds] = useState([]);
  const [blockSenderError, setBlockSenderError] = useState(null);
  const [spamSenderError, setSpamSenderError] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [senderIdToBlock, setSenderIdToBlock] = useState('');
  const [senderIdToSpam, setSenderIdToSpam] = useState('');
  const [modalContent, setModalContent] = useState('');

  const getAllBlockedSenders = () => {
    const sessionToken = localStorage.getItem('admin-panel-sessionToken');
    const blockedSendersPromise = sess_get(
      'admin/console/blocked-senders',
      sessionToken,
    );
    blockedSendersPromise
      .then((res) => {
        setBlockedSenderIds(res.data.response.senders);
      })
      .catch((err) => {
        setBlockSenderError(
          err?.response?.data?.error?.reason
            || 'Some thing went wrong | block sender',
        );
      });
  };

  const getAllSpamSenders = () => {
    const sessionToken = localStorage.getItem('admin-panel-sessionToken');
    const spamSendersPromise = sess_get(
      URL_GET_ALL_SPAM_SENDERS,
      sessionToken,
    );
    spamSendersPromise
      .then((res) => {
        if (res.data.success) {
          setSpamSenderIds(res.data.response.senders);
        }
      })
      .catch((err) => {
        setSpamSenderError(
          err?.response?.data?.error?.reason
            || 'Some thing went wrong | spam sender',
        );
      });
  };

  useEffect(() => {
    getAllBlockedSenders();
    getAllSpamSenders();

    return () => {
      setBlockedSenderIds();
      setSenderIdToSpam();
      setSpamSenderIds();

      // console.log({ blockedSenders }, { blockSenderError });
    };
  }, []);

  const showModalAndAssignSender = (sender) => {
    setShowModal(true);
    setModalContent(sender);
  };

  const blockedSendersHTML = blockedSenders.map((sender) => (
    <tr>
      <td>{sender.sender_id}</td>
      <td>
        <a style={{ color: '#337ab7', cursor: 'pointer' }}>
          <FontAwesomeIcon
            icon={faTrashAlt}
            onClick={(e) => {
              e.preventDefault();
              showModalAndAssignSender(sender);
            }}
          />
        </a>
      </td>
    </tr>
  ));

  const spamSendersHTML = spamSenders.map((sender) => (
    <tr>
      <td>{sender.sender_id}</td>
      <td>
        <FontAwesomeIcon
          icon={faTrashAlt}
          onClick={(e) => {
            e.preventDefault();
            showModalAndAssignSender(sender);
          }}
        />
      </td>
    </tr>
  ));

  const handleButtonClick = async (e) => {
    try {
      const sessionToken = localStorage.getItem('admin-panel-sessionToken');
      const params = {};
      if (e === 'spam') {
        params.is_spam_sender = true;
        params.sender_id = senderIdToSpam;
      } else {
        params.sender_id = senderIdToBlock;
      }
      await sess_post('admin/console/add-sender-to-block-list', sessionToken, params);
      setSenderIdToBlock('');
      setSenderIdToSpam('');
      getAllBlockedSenders();
      getAllSpamSenders();
    } catch (err) {
      if (e === 'block') {
        setBlockSenderError(err.message || 'some thing went wrong');
      } else {
        setSpamSenderError(err.message || 'something went wrong');
      }
    }
  };

  const deleteSenderFromBlockOrSpamList = async (id) => {
    const sessionToken = localStorage.getItem('admin-panel-sessionToken');
    const params = {
      id,
    };
    await sess_delete(URL_DELETE_SENDER_ID, sessionToken, params);
    getAllBlockedSenders();
    getAllSpamSenders();
    setShowModal(false);
  };

  const inpName = 'sender Id';
  const inpText = 'text';

  const placeHolder = 'Enter sender ID';
  const inputId = 'Sender';
  const btnClass = 'btn btn-danger';
  const btnText = 'Add to Spam List';
  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-sm-6" style={{ marginTop: '20px' }}>
          <div className="shadow-panel">
            <div className="col-sm-12">
              <center>
                <h4>Block Sender Id</h4>
              </center>
            </div>
            <FormCard
              setSenderIdToBlockOrSpam={setSenderIdToBlock}
              handleButtonClick={() => { handleButtonClick('block'); }}
              inpName={inpName}
              inpText={inpText}
              placeHolder={placeHolder}
              inputId={inputId}
              btnClass={btnClass}
              btnText="Add to Block List"
              value={senderIdToBlock}
            />
            <Add91Note />
            <ShowError error={blockSenderError} />
          </div>
        </div>
        <div className="col-sm-6" style={{ marginTop: '20px' }}>
          <div className="shadow-panel">
            <div className="col-sm-12">
              <center>
                <h4>Block Sender Id</h4>
              </center>
            </div>
            <FormCard
              setSenderIdToBlockOrSpam={setSenderIdToSpam}
              handleButtonClick={() => { handleButtonClick('spam'); }}
              inpName={inpName}
              inpText={inpText}
              placeHolder={placeHolder}
              inputId={inputId}
              btnClass={btnClass}
              btnText={btnText}
              value={senderIdToSpam}
            />
            <Add91Note />
            <ShowError error={spamSenderError} />
          </div>
        </div>

        <div className="col-sm-6" style={{ marginTop: '20px' }}>
          <div className="shadow-panel">
            <table className="table table-hover mb-table">
              <thead>
                <tr>
                  <th scope="col">SenderId</th>
                </tr>
              </thead>
              <tbody>
                {blockedSendersHTML}
                {blockSenderError && (
                <tr colSpan="99" className="text-center text-danger">
                  {blockSenderError}
                </tr>
                )}
              </tbody>
            </table>
          </div>
          <OperationModal
            show={showModal}
            title="Delete Sender"
            success={() => deleteSenderFromBlockOrSpamList(modalContent._id)}
            setShowModal={setShowModal}
            modalContent={`Are you sure want to delete sender ${modalContent.sender_id}?`}
            onHide={() => { setShowModal(false); }}
          />
        </div>
        <div className="col-sm-6" style={{ 'margin-top': '20px' }}>
          <div className="shadow-panel">
            <table className="table table-hover mb-table">
              <thead>
                <tr>
                  <th scope="col">SenderId</th>
                </tr>
              </thead>
              <tbody>
                {spamSendersHTML}

                {spamSenderError && (
                <tr colSpan="99" className="text-center text-danger">
                  {spamSenderError}
                </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}
export default BlockSender;
